/*=================================================
    summary: 老師 看 / 改 學生考卷 視窗

    remarks: 000 Tim 2021/11/30 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentAnswerWindow from './AssignmentAnswerWindow.module.scss'


// // 準備移除 App 取得資料 流程   Tim22.08.09
// import * as AppDataAccess from '../../Utils/AppDataAccess'
import * as WebDataAccess from '../../Utils/WebDataAccess'

import AssignmentPinyinIdentification from './Units/AssignmentPinyinIdentification/AssignmentPinyinIdentification'
import AssignmentPinyinDictation from './Units/AssignmentPinyinDictation/AssignmentPinyinDictation'
import AssignmentChoiceQuestion from './Units/AssignmentChoiceQuestion/AssignmentChoiceQuestion'
import AssignmentFillInQuestion from './Units/AssignmentFillInQuestion/AssignmentFillInQuestion'
import AssignmentComposition from './Units/AssignmentComposition/AssignmentComposition'
import AssignmentFluency from './Units/AssignmentFluency/AssignmentFluency'

import ViderPlayerWindow from '../ViderPlayerWindow/ViderPlayerWindow'
import AudioRecordingWindow from '../../LearningUnit/LUUtils/AudioRecordingWindow/AudioRecordingWindow'
import ImageDisplayWindow from '../ImageDisplayWindow/ImageDisplayWindow'

import {LoadingMask, AlertWindow, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region State Member Variables
let mintStateScore = 0
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mstrBookCatID = ""
let mobjCallParam = null
let marrLearningUnit = []
let mobjTeacherAssignment = null
let mintQuestionType = 0
let mobjLearningUnit = null
let mintTatolPage = 1
let marrPage = []
let marrTeacherFeedback = []

let mblnScrollToTop = false
let mobjShowComponentParam = null

let mfuncGetTeacherFeedback = null
let mfuncARWWithResult = null       // AudioRecordingWindowCloseWithResult
// #endregion Member Variables


const COMP_NAME = "AssignmentAnswerWindow"

function AssignmentAnswerWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [pageIndex, setPageIndex] = useState(0)
    const [score, setScore] = useState("")
    const [isShowViderPlayerWindow, setIsShowViderPlayerWindow] = useState(false)
    const [isShowAudioRecordingWindow, setIsShowAudioRecordingWindow] = useState(false)
    const [isShowImageDisplayWindow, setIsShowImageDisplayWindow] = useState(false)

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefSubSubContent = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefScrollToTop = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    mrefScrollToTop.current = ScrollToTop
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update score
    useEffect(() => {
        mintStateScore = score
    }, [score])

    // Update pageIndex
    useEffect(() => {
        if (mblnScrollToTop)
        {
            mblnScrollToTop = false
            setTimeout(function()
            {
                mrefScrollToTop.current()
            }, 50)
        }
    }, [pageIndex])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // setIsShowImageDisplayWindow(true)

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.ComponentFuncEntry.LessonsRef = null
            mfuncGetTeacherFeedback = null
            mfuncARWWithResult = null
            marrTeacherFeedback = []
            mblnScrollToTop = false
            mstrBookCatID = ""

            mblnInitialized = false

            setUpdateDataTime(0)
        }
    }, [props.AssignmentData])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 上一個 頁面
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowAssignmentAnswerWindow"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 上一頁
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function PrevOnTapHandler(StatePageIndex)
    {
        console.log(COMP_NAME + ".PrevOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // 不是 再打分數 頁面
        if (
            (StatePageIndex < mintTatolPage) &&
            (mfuncGetTeacherFeedback !== null)
            )
        {
            if (mintQuestionType !== window.gQuestionTypeEnum.CompositionQuestion)
            {
                marrTeacherFeedback = mfuncGetTeacherFeedback()
                SetTeacherFeedback(marrTeacherFeedback)
            }
            else
            {
                let objTeacherFeedback = mfuncGetTeacherFeedback()
                SetTeacherFeedback4Composition(objTeacherFeedback)
            }
        }
        

        if ((StatePageIndex - 1) < mintTatolPage)
        {
            mblnScrollToTop = true
        }

        setPageIndex(StatePageIndex - 1)
    } // end of PrevOnTapHandler

    /*===========================================
    summary: 點選 下一頁
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function NextOnTapHandler(StatePageIndex)
    {
        console.log(COMP_NAME + ".NextOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // 不是 再打分數 頁面
        if (
            (StatePageIndex < mintTatolPage) &&
            (mfuncGetTeacherFeedback !== null)
            )
        {
            if (mintQuestionType !== window.gQuestionTypeEnum.CompositionQuestion)
            {
                marrTeacherFeedback = mfuncGetTeacherFeedback()
                SetTeacherFeedback(marrTeacherFeedback)
            }
            else
            {
                let objTeacherFeedback = mfuncGetTeacherFeedback()
                SetTeacherFeedback4Composition(objTeacherFeedback)
            }
        }

        if ((StatePageIndex + 1) < mintTatolPage)
        {
            mblnScrollToTop = true
        }

        setPageIndex(StatePageIndex + 1)
    } // end of NextOnTapHandler

    /*===========================================
    summary: 點選 送出考卷
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function SubmitOnTapHandler(StateScore)
    {
        console.log(COMP_NAME + ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objAlertObject = null

        if (
            (typeof(StateScore) === 'undefined') ||
            (StateScore === null) ||
            (StateScore === "") ||
            (isNaN(StateScore))
            )
        {
            
            objAlertObject = {
                Header: "",
                Body: window.gAppUI.ERR_AnswerScoreNotEntered,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
        }
        else if (
            (parseInt(StateScore) < 0) || 
            (parseInt(StateScore) > 100)
            )
        {
            objAlertObject = {
                Header: "",
                Body: window.gAppUI.ERR_AnswerScoreExceed,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
        }
        else
        {
            objAlertObject = {
                Header: "",
                Body: window.gAppUI.MSG_AssignmentSubmitCheck4One,
                ShowCloseButton: false,
                CallbackRef: SubmitCheckAlertCallback,
                Buttons: [
                    {
                        Text: window.gAppUI.BTN_Cancel,
                        AutoFocus: false
                    },
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
        }

        ShowAlert(objAlertObject)
    } // end of SubmitOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 分數 改變 事件
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ScoreChangeHandler(e)
    {
        console.log(COMP_NAME + ".ScoreChangeHandler: ", e)
        setScore(e.target.value)
    } // end of ScoreChangeHandler
    // #endregion Other EventHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "RegisterGetTeacherFeedback")
        {
            mfuncGetTeacherFeedback = CallbackObj.Function
        }
        else if (CallbackObj.Action === "RegisterAudioRecordingWindowCloseWithResult")
        {
            mfuncARWWithResult = CallbackObj.Function
        }
        else if (CallbackObj.Action === "OpenShowViderPlayerWindow")
        {
            // "Arguments": {
            //     "Title": "",
            //     "VideoUrl": TeacherFeedbackVideoUrl,
            //     "PosterUrl": strPosterUrl
            // }
            mobjShowComponentParam = {
                "Arguments": CallbackObj.Arguments
            }
            setIsShowViderPlayerWindow(true)
        }
        else if (CallbackObj.Action === "CloseShowViderPlayerWindow")
        {
            mobjShowComponentParam = null
            setIsShowViderPlayerWindow(false)
        }
        else if (CallbackObj.Action === "OpenShowAudioRecordingWindow")
        {
            setIsShowAudioRecordingWindow(true)
        }
        else if (CallbackObj.Action === "AudioRecordingWindowCloseWithoutResult")
        {
            console.log("AudioRecordingWindowCloseWithoutResult.CallbackObj: ", CallbackObj)

            setIsShowAudioRecordingWindow(false)

            setTimeout(function ()
            {
                if (mfuncARWWithResult !== null)
                {
                    mfuncARWWithResult(null)
                } // end of if (mfuncARWWithResult !== null)
            }, 10)
        }
        else if (CallbackObj.Action === "AudioRecordingWindowCloseWithResult")
        {
            console.log("AudioRecordingWindowCloseWithResult.CallbackObj: ", CallbackObj)
            
            setIsShowAudioRecordingWindow(false)

            setTimeout(function ()
            {
                if (mfuncARWWithResult !== null)
                {
                    mfuncARWWithResult(CallbackObj.AudioBase64)
                } // end of if (mfuncARWWithResult !== null)
            }, 10)
        }
        else if (CallbackObj.Action === "OpenShowImageDisplayWindow")
        {
            // "Arguments": {
            //     "ImageType":
            //     "ImageUrl": ImageAnswerUrl
            // }
            mobjShowComponentParam = {
                "Arguments": CallbackObj.Arguments
            }
            setIsShowImageDisplayWindow(true)
        }
        else if (CallbackObj.Action === "CloseShowImageDisplayWindow")
        {
            mobjShowComponentParam = null
            setIsShowImageDisplayWindow(false)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region ComponentFuncEntry
    /*===========================================
    summary: 接收 AppDataAccess or WebDataAccess Callback的流程
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentFuncEntry(CallObject)
    {
        console.log(COMP_NAME + ".ComponentFuncEntry: ", CallObject)

        if (CallObject.Func === "GetLessonDataFromWebProcessEnd")
        {
            GetLessonDataProcessEnd(CallObject.LessonID)
        }
        else if (CallObject.Func === "GetLessonDataFromAppProcessEnd")
        {
            GetLessonDataProcessEnd(CallObject.LessonID)
        }
        else if (CallObject.Func === "GetLessonDataFromAppProcessEnd4Error")
        {
            if (CallObject.ErrMsg === window.gAppUI.ERR_NoInternetService4DownloadLessonData)
            {
                let objAlertObject = {
                    Header: "",
                    Body: window.gAppUI.ERR_NoInternetService4DownloadLessonData,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            }
        }
        else
        {
            console.log(COMP_NAME + ".ComponentFuncEntry: unspported func: ", CallObject.Func)
        }
    } // end of ComponentFuncEntry
    // #endregion ComponentFuncEntry

    // #region AlertCallBack
    /*===========================================
    summary: 確認答案處理
    remarks: 000 Tim 2020/12/01 Create
    ===========================================*/
    function SubmitCheckAlertCallback (BtnObject)
    {
        console.log(COMP_NAME + ".SubmitCheckAlertCallback: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            ExecuteSubmit()
        }
    } // end of SubmitCheckAlertCallback
    // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.ComponentFuncEntry.LessonsRef = ComponentFuncEntry

        GetLessonDataProcessBegin(props.AssignmentData.LessonID)
    } // end of PaintedMe

    /*===========================================
    summary: 初始化 老師頁面
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function InitTeacherContain(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".InitTeacherContain mobjTeacherAssignment: ", mobjTeacherAssignment)
        console.log(COMP_NAME + ".InitTeacherContain LUCatSeqNo: ", LUCatSeqNo)
                
        switch (parseInt(LUCatSeqNo))
        {
            case window.gDCPLUEnum.PracticePinyinIdentification:            // 11
                mintQuestionType = window.gQuestionTypeEnum.PinyinIdentification
                break
            case window.gDCPLUEnum.PracticePinyinDictation:                // 12
                mintQuestionType = window.gQuestionTypeEnum.PinyinDictation
                break
            case window.gDCPLUEnum.PracticeListening:                      // 13
            case window.gDCPLUEnum.PracticeReadingComprehension:           // 15
            case window.gDCPLUEnum.ReviewListening:                      // 20
            case window.gDCPLUEnum.ReviewReading:                        // 21
                mintQuestionType = window.gQuestionTypeEnum.ChoiceQuestion
                break
            case window.gDCPLUEnum.PracticeSpeaking:                       // 14
            case window.gDCPLUEnum.PracticeWritingComposition:             // 18
            case window.gDCPLUEnum.PracticeActivity:                       // 19
            case window.gDCPLUEnum.ReviewWritingComposition:             // 22
            case window.gDCPLUEnum.ReviewSpeaking:                       // 23
                mintQuestionType = window.gQuestionTypeEnum.CompositionQuestion
                break
            
            case window.gDCPLUEnum.PracticeWritingGrammarExercises:        // 26
            case window.gDCPLUEnum.ReviewWritingGrammarExercises:        // 27
                mintQuestionType = window.gQuestionTypeEnum.FillInQuestion
                break
            case window.gDCPLUEnum.PracticeFluency:        // 28
                mintQuestionType = window.gQuestionTypeEnum.Fluency
                break
            default:
                break
        } // end of switch (parseInt(LUCatSeqNo))

        mobjLearningUnit = GetLUObject(parseInt(LUCatSeqNo))
        marrPage = []

        console.log("mobjLearningUnit: ", mobjLearningUnit)
        console.log("mintQuestionType: ", mintQuestionType)

        if (mintQuestionType === window.gQuestionTypeEnum.CompositionQuestion)      // 4
        {
            mintTatolPage = mobjTeacherAssignment.NewAssignList[0].AnswerList.length
            marrTeacherFeedback = []

            let objTeacherFeedback = null
            let intIndex = 0
            let intCount = mintTatolPage

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                objTeacherFeedback = {
                    "AnswerID": -1,
                    "TeacherFeedbackText": "",
                    "TeacherFeedbackAudioFN": "",
                    "TeacherFeedbackVideoFN": ""
                }
                
                marrTeacherFeedback.push(objTeacherFeedback)
                marrPage.push(intIndex + 1)
            } // end of for (intIndex = 0;

            if (props.AssignmentData.AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
            {
                marrPage.push(mintTatolPage + 1)
            }

            console.log("InitTeacherContain CompositionQuestion marrTeacherFeedback: ", marrTeacherFeedback)
        }
        else
        {
            // window.gQuestionTypeEnum.PinyinIdentification:     // 5
            // window.gQuestionTypeEnum.PinyinDictation:          // 6
            // window.gQuestionTypeEnum.ChoiceQuestion:           // 2
            // window.gQuestionTypeEnum.FillInQuestion:           // 3
            // window.gQuestionTypeEnum.Fluency:                  // 7
            mintTatolPage = 1

            marrPage.push(1)

            if (props.AssignmentData.AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
            {
                marrPage.push(mintTatolPage + 1)
            }
        }
    } // end of InitTeacherContain

    /*===========================================
    summary: 取得 LU 物件資料
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetLUObject(LUSeqNo)
    {
        console.log(COMP_NAME + ".GetLUObject LUSeqNo: ", LUSeqNo)

        let intLUSeqNo = LUSeqNo
        if (LUSeqNo === window.gDCPLUEnum.CanDoStatements)
        {
            intLUSeqNo = window.gDCPLUEnum.LessonGoals
        }
        else if (LUSeqNo === window.gDCPLUEnum.PracticeFluency)
        {
            intLUSeqNo = window.gDCPLUEnum.LessonLessonText
        }

        let objLUData = marrLearningUnit.find(LearningUnit => parseInt(LearningUnit.LUCatSeqNo) === parseInt(intLUSeqNo))

        return objLUData
    } // end of GetLUObject

    /*===========================================
    summary: 設定 老師 評語
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function SetTeacherFeedback(TeacherFeedbackArray)
    {
        console.log(COMP_NAME + ".SetTeacherFeedback TeacherFeedbackArray: ", TeacherFeedbackArray)

        let intNAIndex = 0
        if (
            (typeof(mobjTeacherAssignment) !== 'undefined') &&
            (mobjTeacherAssignment !== null) &&
            (typeof(mobjTeacherAssignment.NewAssignList) !== 'undefined') &&
            (mobjTeacherAssignment.NewAssignList !== null) &&
            (mobjTeacherAssignment.NewAssignList.length > 0) &&
            (typeof(mobjTeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (mobjTeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            let intIndex = 0
            let intCount = mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList.length

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                if (
                    (typeof(TeacherFeedbackArray[intIndex]) !== 'undefined') &&
                    (TeacherFeedbackArray[intIndex] !== null) &&
                    (typeof(TeacherFeedbackArray[intIndex].TeacherFeedbackText) !== 'undefined') &&
                    (TeacherFeedbackArray[intIndex].TeacherFeedbackText !== null) &&
                    (TeacherFeedbackArray[intIndex].TeacherFeedbackText !== "") 
                    )
                {
                    mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList[intIndex].TeacherFeedbackText = TeacherFeedbackArray[intIndex].TeacherFeedbackText
                }                
            } // end of for (intIndex = 0;
        } // end of if (mobjTeacherAssignment !== null)

        console.log(COMP_NAME + ".SetTeacherFeedback END mobjTeacherAssignment: ", mobjTeacherAssignment)
    } // end of SetTeacherFeedback

    /*===========================================
    summary: 設定 老師 評語 For Composition
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function SetTeacherFeedback4Composition(TeacherFeedback)
    {
        console.log(COMP_NAME + ".SetTeacherFeedback4Composition TeacherFeedback: ", TeacherFeedback)

        let intPageIndex = TeacherFeedback.PageIndex
        let intNAIndex = 0
        if (
            (typeof(mobjTeacherAssignment) !== 'undefined') &&
            (mobjTeacherAssignment !== null) &&
            (typeof(mobjTeacherAssignment.NewAssignList) !== 'undefined') &&
            (mobjTeacherAssignment.NewAssignList !== null) &&
            (mobjTeacherAssignment.NewAssignList.length > 0) &&
            (typeof(mobjTeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (mobjTeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            let intCount = mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList.length

            if (
                (intPageIndex < intCount) &&
                (TeacherFeedback !== null)
                )
            {
                marrTeacherFeedback[intPageIndex].AnswerID = TeacherFeedback.AnswerID
                
                if (
                    (typeof(TeacherFeedback.TeacherFeedbackText) !== 'undefined') &&
                    (TeacherFeedback.TeacherFeedbackText !== null) &&
                    (TeacherFeedback.TeacherFeedbackText !== "") 
                    )
                {
                    mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList[intPageIndex].TeacherFeedbackText = TeacherFeedback.TeacherFeedbackText
                    marrTeacherFeedback[intPageIndex].TeacherFeedbackText = TeacherFeedback.TeacherFeedbackText
                }
                
                if (
                    (typeof(TeacherFeedback.TeacherFeedbackAudioFN) !== 'undefined') &&
                    (TeacherFeedback.TeacherFeedbackAudioFN !== null) &&
                    (TeacherFeedback.TeacherFeedbackAudioFN !== "") 
                    )
                {
                    mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList[intPageIndex].TeacherFeedbackAudioFN = TeacherFeedback.TeacherFeedbackAudioFN
                    marrTeacherFeedback[intPageIndex].TeacherFeedbackAudioFN = TeacherFeedback.TeacherFeedbackAudioFN
                }

                if (
                    (typeof(TeacherFeedback.TeacherFeedbackVideoFN) !== 'undefined') &&
                    (TeacherFeedback.TeacherFeedbackVideoFN !== null) &&
                    (TeacherFeedback.TeacherFeedbackVideoFN !== "") 
                    )
                {
                    mobjTeacherAssignment.NewAssignList[intNAIndex].AnswerList[intPageIndex].TeacherFeedbackVideoFN = TeacherFeedback.TeacherFeedbackVideoFN
                    marrTeacherFeedback[intPageIndex].TeacherFeedbackVideoFN = TeacherFeedback.TeacherFeedbackVideoFN
                }
            } // end of if (intPageIndex < intCount)
        } // end of if (mobjTeacherAssignment !== null)

        console.log(COMP_NAME + ".SetTeacherFeedback4Composition END mobjTeacherAssignment: ", mobjTeacherAssignment)
        console.log(COMP_NAME + ".SetTeacherFeedback4Composition END marrTeacherFeedback: ", marrTeacherFeedback)
    } // end of SetTeacherFeedback4Composition

    /*===========================================
    summary: 滾到最上位
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function ScrollToTop()
    {
        console.log(COMP_NAME + ".ScrollToTop")
        if (mrefSubSubContent.current !== null)
        {
            mrefSubSubContent.current.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        } // end of if (mrefSubSubContent.current !== null)
    } // end of ScrollToTop

    /*===========================================
    summary: 執行 送出資料
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function ExecuteSubmit()
    {
        mobjCallParam = {
            "AssignID": props.AssignmentData.AssignID,
            "StudentAccID": props.AssignmentData.StudentID,
            "ClassID": props.AssignmentData.AssignedClassID,
            "Score": mintStateScore,
            "TeacherFeedbackList": marrTeacherFeedback
        }
        console.log("mobjCallParam:", mobjCallParam)
        TeacherScoreNewAssignment()
    } // end of ExecuteSubmit
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 SubContent Cls
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetSubContentCls(QuestionType, AssignReportStatus) 
    {
        let objCls = cssAssignmentAnswerWindow.divSubContent

        if (
            (
                (AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore) &&
                (
                    (QuestionType === window.gQuestionTypeEnum.PinyinDictation) ||  // 6
                    (QuestionType === window.gQuestionTypeEnum.FillInQuestion)      // 3 
                )
            ) ||
            (QuestionType === window.gQuestionTypeEnum.CompositionQuestion)         // 4
            )
        {
            objCls = cssAssignmentAnswerWindow.divSubContent4Tool
        }

        return objCls
    } // end of GetSubContentCls

    /*===========================================
    summary: 取得 CompositionQuestionSubContent Cls
    remarks: 000 Tim 2022/01/18 Create
    ===========================================*/
    function GetCompositionQuestionSubContentCls(PageList) 
    {
        let objCls = cssAssignmentAnswerWindow.divCompositionQuestionSubContent4OnePage

        if (PageList.length > 1)
        {
            objCls = cssAssignmentAnswerWindow.divCompositionQuestionSubContent
        }

        return objCls
    } // end of GetCompositionQuestionSubContentCls

    /*===========================================
    summary: 取得 PageIcon Cls
    remarks: 000 Tim 2021/12/28 Create
    ===========================================*/
    function GetPageIconCls(PageIndex, StatePageIndex) 
    {
        let objCls = cssAssignmentAnswerWindow.divPageIconUnSelect

        if (PageIndex === StatePageIndex)
        {
            objCls = cssAssignmentAnswerWindow.divPageIconSelected
        }

        return objCls
    } // end of GetPageIconCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 老師打分數，並且評語 後續流程
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function TeacherScoreNewAssignmentAfterProcess ()
    {   
        console.log(COMP_NAME + ".TeacherScoreNewAssignmentAfterProcess")

        let objCallbackData = {
            "Action": "SubmitSuccessAssignmentAnswerWindow",
            "AssignID": mobjCallParam.AssignID,
            "Score": mobjCallParam.Score
        }
        props.CallbackRef(objCallbackData)

        mobjCallParam = null
    } // end of TeacherScoreNewAssignmentAfterProcess

    /*===========================================
    summary: 取得 需要打分數的作業 後續流程
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetNewAssignmentAssignAnswerAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetNewAssignmentAssignAnswerAfterProcess")

        mobjTeacherAssignment = ReturnData
        
        InitTeacherContain(mobjCallParam.LUCatSeqNo)

        setUpdateDataTime(new Date().getTime())

        mobjCallParam = null
    } // end of GetNewAssignmentAssignAnswerAfterProcess
    // #endregion Web Service After Process

    // #region Web Service 
    /*===========================================
    summary: 取得 需要打分數的作業
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetNewAssignmentAssignAnswer ()
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignAnswer")

        let objRetryFuncRef = GetNewAssignmentAssignAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetNewAssignmentAssignAnswerCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetNewAssignmentAssignAnswer)

            let objCallData = {
                "Func": "GetNewAssignmentAssignAnswer",
                "Assignee": mobjCallParam.AccountID,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "AssignID": mobjCallParam.AssignID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetNewAssignmentAssignAnswer

    /*===========================================
    summary: 取得 需要打分數的作業 Callback
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetNewAssignmentAssignAnswerCallback (Return)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignAnswerCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetNewAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetNewAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetNewAssignmentAssignAnswerCallback Return.Data: ", Return.Data)

            GetNewAssignmentAssignAnswerAfterProcess(Return.Data)
        }
    } // end of GetNewAssignmentAssignAnswerCallback

    /*===========================================
    summary: 老師打分數，並且評語
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function TeacherScoreNewAssignment ()
    {
        console.log(COMP_NAME + ".TeacherScoreNewAssignment")

        let objRetryFuncRef = TeacherScoreNewAssignment
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = TeacherScoreNewAssignmentCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_TeacherScoreNewAssignment)

            let objCallData = {
                "Func": "TeacherScoreNewAssignment",
                "AssignID": mobjCallParam.AssignID,
                "StudentAccID": mobjCallParam.StudentAccID,
                "ClassID": mobjCallParam.ClassID,
                "Score": mobjCallParam.Score,
                "TeacherFeedbackList": JSON.stringify(mobjCallParam.TeacherFeedbackList)
            }
            console.log("objCallData.TeacherFeedbackList:", objCallData.TeacherFeedbackList)
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of TeacherScoreNewAssignment

    /*===========================================
    summary: 老師打分數，並且評語 Callback
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function TeacherScoreNewAssignmentCallback (Return)
    {
        console.log(COMP_NAME + ".TeacherScoreNewAssignmentCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_TeacherScoreAssignment_No
        let strErrorTitle = window.gAppUI.ERR_TeacherScoreAssignment_Title
        let strErrMsg = window.gAppUI.ERR_TeacherScoreAssignment_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("TeacherScoreNewAssignmentCallback: ErrNo: ", Return.ErrNo)
            console.log("TeacherScoreNewAssignmentCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("TeacherScoreNewAssignmentCallback Return.Data: ", Return.Data)

            TeacherScoreNewAssignmentAfterProcess()
        }
    } // end of TeacherScoreNewAssignmentCallback
    // #endregion Web Service 

    // #region Back From App Call
    // function BackFromAppCallbackVideoRecordFromApp(ReturnData) 
    // {
    //     console.log(xtype + ".BackFromAppCallbackVideoRecordFromApp:", ReturnData, mobjQuestion);
    //     if (mobjQuestion !== null)
    //     {
    //         mobjQuestion.BackFromAppCallbackVideoRecordFromApp(ReturnData);
    //     }
    // } // end of BackFromAppCallbackVideoRecordFromApp
    // #region Back From App Call

    // #region Call App
    /*===========================================
    summary: 取得 Lesson資料 流程 開始
    remarks: 000 Tim 2021/11/30 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function GetLessonDataProcessBegin (LessonID)
    {
        console.log(COMP_NAME + ".GetLessonDataProcessBegin: App.BookCatID: ", window.gSession.App.BookCatID)
        console.log(COMP_NAME + ".GetLessonDataProcessBegin: LessonID: ", LessonID)

        if (
            (typeof(LessonID) !== 'undefined') &&
            (LessonID !== null) &&
            (parseInt(LessonID) > 0) &&
            (window.gSession.App.CurrentLesson.ID === LessonID)
            )
        {
            GetLessonDataProcessEnd(LessonID)
        }
        else
        {
            // // 準備移除 App 取得資料 流程   Tim22.08.09
            // if (window.gSession.App.InApp)
            // {
            //     AppDataAccess.GetLessonDataFromAppProcessBegin(window.gSession.App.BookCatID, LessonID)
            // }
            // else
            // {
                OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetLessonDataProcess)

                WebDataAccess.GetLessonDataFromWebProcessBegin(window.gSession.App.BookCatID, LessonID)
            // }
        }
    } // end of GetLessonDataProcessBegin

    /*===========================================
    summary: 取得 Lesson資料 流程 結束
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetLessonDataProcessEnd(CallbackObject)
    {
        console.log(COMP_NAME + ".GetLessonDataProcessEnd: ", CallbackObject)

        console.log("App.CurrentLesson.ID: ", window.gSession.App.CurrentLesson.ID)

        marrLearningUnit = window.gSession.App.CurrentLesson.Def.LearningUnit
        
        mobjCallParam = {
            "AccountID": props.AssignmentData.StudentID,
            "BookCategoryID": mstrBookCatID,      // 左邊補零 Format "01" 
            "LessonID": props.AssignmentData.LessonID.toString().PadLeft(5),            // 左邊補零 Format "01001"
            "LUCatSeqNo": props.AssignmentData.LUCatSeqNo,
            "AssignID": props.AssignmentData.AssignID
        }
        GetNewAssignmentAssignAnswer()
    } // end of GetLessonDataProcessEnd
    // #endregion Call App

    // #region Render元件
    /*===========================================
    summary: 下一頁按鈕 顯示Component  
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ComponentNextButton( {StatePageIndex, TatolPage, QuestionType, AssignReportStatus} )
    {   
        let objButton = null
        if (
            (AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore) ||
            (QuestionType !== window.gQuestionTypeEnum.CompositionQuestion)         // 4
            )
        {
            if (StatePageIndex < TatolPage)
            {
                objButton = <div className={cssAssignmentAnswerWindow.btnNext} onClick={() => NextOnTapHandler(StatePageIndex)}/>
            }
            else
            {
                objButton = <div className={cssAssignmentAnswerWindow.btnSubmit} onClick={() => SubmitOnTapHandler(score)}>
                                {window.gAppUI.BTN_Submit}
                            </div>
            }
        }
        else
        {
            if ((StatePageIndex + 1) < TatolPage)
            {
                objButton = <div className={cssAssignmentAnswerWindow.btnNext} onClick={() => NextOnTapHandler(StatePageIndex)}/>
            }
        }

        return(
            <div className={cssAssignmentAnswerWindow.divNextArea}>
                {objButton}
            </div>
        )
    } // end of ComponentPrevButton

    /*===========================================
    summary: 上一頁按鈕 顯示Component  
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ComponentPrevButton( {StatePageIndex} )
    {   
        let objButton = null
        if (StatePageIndex > 0)
        {
            objButton = <div className={cssAssignmentAnswerWindow.btnPrev} onClick={() => PrevOnTapHandler(StatePageIndex)}/>
        }

        return(
            <div className={cssAssignmentAnswerWindow.divPrevArea}>
                {objButton}
            </div>
        )
    } // end of ComponentPrevButton
                    
    /*===========================================
    summary: Score 顯示Component  
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ComponentScore( {StateUpdateDataTime, TeacherAssignment} )
    {   
        if (
            (StateUpdateDataTime > 0) &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (typeof(TeacherAssignment.NewAssignList[0]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[0] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[0].Score) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[0].Score !== null)
            )
        {
            let strScore = window.gAppUI.LBL_Score + ": " + TeacherAssignment.NewAssignList[0].Score.toString()
            return(
                <div className={cssAssignmentAnswerWindow.divScore}>
                    {strScore}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentScore
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render ImageDisplayWindow 的顯示
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function RenderImageDisplayWindowWrapper(StateIsShowImageDisplayWindow)
    {
        if (StateIsShowImageDisplayWindow)
        {
            // "Arguments": {
            //     "ImageType":
            //     "ImageUrl": ImageAnswerUrl
            // }
            return(
                <ImageDisplayWindow Arguments={mobjShowComponentParam.Arguments}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderImageDisplayWindowWrapper

    /*===========================================
    summary: Render Audio Recording Window 的顯示
    remarks: 000 Tim 2021/12/15 Create
    ===========================================*/
    function RenderAudioRecordingWindowWrapper(IsShowAudioRecordingWindow)
    {
        if (IsShowAudioRecordingWindow)
        {
            return(
                <AudioRecordingWindow CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAudioRecordingWindowWrapper

    /*===========================================
    summary: Render ViderPlayerWindow 的顯示
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function RenderViderPlayerWindowWrapper(StateIsShowViderPlayerWindow)
    {
        if (StateIsShowViderPlayerWindow)
        {
            // "Arguments": {
            //     "Title": "",
            //     "VideoUrl": TeacherFeedbackVideoUrl,
            //     "PosterUrl": strPosterUrl
            // }
            return(
                <ViderPlayerWindow Arguments={mobjShowComponentParam.Arguments}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderViderPlayerWindowWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderQuestionWrapper(QuestionType)
    {
        let objBlock = null

        switch (QuestionType)
        {
            case window.gQuestionTypeEnum.PinyinIdentification: // 5
                objBlock = <AssignmentPinyinIdentification LearningUnitData={mobjLearningUnit} 
                                TeacherAssignmentData={mobjTeacherAssignment}
                                BookCatID={mstrBookCatID}
                                LessonID={props.AssignmentData.LessonID}/>
                break
            case window.gQuestionTypeEnum.PinyinDictation:      // 6
                objBlock = <AssignmentPinyinDictation LearningUnitData={mobjLearningUnit} 
                                TeacherAssignmentData={mobjTeacherAssignment}
                                BookCatID={mstrBookCatID}
                                LessonID={props.AssignmentData.LessonID}
                                AssignReportStatus={props.AssignmentData.AssignReportStatus}
                                CallbackRef={ComponentCallback}/>
                break
            case window.gQuestionTypeEnum.ChoiceQuestion:      // 2
                objBlock = <AssignmentChoiceQuestion LearningUnitData={mobjLearningUnit} 
                                TeacherAssignmentData={mobjTeacherAssignment}
                                BookCatID={mstrBookCatID}
                                LessonID={props.AssignmentData.LessonID}
                                CallbackRef={ComponentCallback}/>
                break
            case window.gQuestionTypeEnum.FillInQuestion:      // 3
                objBlock = <AssignmentFillInQuestion LearningUnitData={mobjLearningUnit} 
                                TeacherAssignmentData={mobjTeacherAssignment}
                                BookCatID={mstrBookCatID}
                                LessonID={props.AssignmentData.LessonID}
                                AssignReportStatus={props.AssignmentData.AssignReportStatus}
                                CallbackRef={ComponentCallback}/>
                break
            case window.gQuestionTypeEnum.CompositionQuestion:  // 4
                objBlock = <AssignmentComposition LearningUnitData={mobjLearningUnit} 
                                TeacherAssignmentData={mobjTeacherAssignment}
                                BookCatID={mstrBookCatID}
                                LessonID={props.AssignmentData.LessonID}
                                AssignReportStatus={props.AssignmentData.AssignReportStatus}
                                PageIndex={pageIndex}
                                CallbackRef={ComponentCallback}/>
                break
            case window.gQuestionTypeEnum.Fluency:    // 7
                objBlock = <AssignmentFluency LearningUnitData={mobjLearningUnit} 
                                TeacherAssignmentData={mobjTeacherAssignment}
                                BookCatID={mstrBookCatID}
                                LessonID={props.AssignmentData.LessonID}
                                CallbackRef={ComponentCallback}/>
                break
            default:
                break
        } // end of switch (QuestionType)

        return objBlock
    } // end of RenderQuestionWrapper

    /*===========================================
    summary: Render 頁數 的顯示
    remarks: 000 Tim 2021/12/28 Create
    ===========================================*/
    function RenderPageWrapper(StatePageIndex)
    {
        if (marrPage.length > 1)
        {
            return(
                <div className={cssAssignmentAnswerWindow.divPageArea}>
                    {marrPage.map((PageData, PageIndex) => 
                        <div key={PageIndex} className={GetPageIconCls(PageIndex, StatePageIndex)} />
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderPageWrapper

    /*===========================================
    summary: Render Bottom Tool 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderBottomToolWrapper(QuestionType, StatePageIndex, TatolPage, AssignReportStatus)
    {
        if (
                (
                    (
                        (AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore) &&
                            (
                                (QuestionType === window.gQuestionTypeEnum.PinyinDictation) ||  // 6
                                (QuestionType === window.gQuestionTypeEnum.FillInQuestion)      // 3
                            )
                    ) ||
                    (QuestionType === window.gQuestionTypeEnum.CompositionQuestion)         // 4
                ) &&
                (marrPage.length > 1)
            )
        {
            // PinyinDictation 且 為打分數模式 才 增加打分數頁面    Tim21.12.01
            return (
                <div className={cssAssignmentAnswerWindow.divBottomTool}>
                    <ComponentPrevButton StatePageIndex={StatePageIndex} />
                    {RenderPageWrapper(StatePageIndex)}
                    <ComponentNextButton StatePageIndex={StatePageIndex} TatolPage={TatolPage} QuestionType={QuestionType} AssignReportStatus={AssignReportStatus}/>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBottomToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderSubContentWrapper(StatePageIndex, TatolPage)
    {
        if (StatePageIndex < TatolPage)
        {
            if (mintQuestionType === window.gQuestionTypeEnum.CompositionQuestion)         // 4
            {
                return (
                    <div className={GetCompositionQuestionSubContentCls(marrPage)}>
                        {RenderQuestionWrapper(mintQuestionType)}
                    </div>
                )
            }
            else
            {
                return (
                    <div className={GetSubContentCls(mintQuestionType, props.AssignmentData.AssignReportStatus)}>
                        <div ref={mrefSubSubContent} className={cssAssignmentAnswerWindow.divSubSubContent}>
                            {RenderQuestionWrapper(mintQuestionType)}
                        </div>
                    </div>
                )
            }
        }
        else
        {
            return (
                <div className={GetSubContentCls(mintQuestionType, props.AssignmentData.AssignReportStatus)}>
                    <div className={cssAssignmentAnswerWindow.divScoreTitle}>
                        {window.gAppUI.LBL_Score}
                    </div>

                    <label htmlFor="txtScore" className={cssAssignmentAnswerWindow.divHidden}>
                        {window.gAppUI.LBL_AnswerScorePlaceHolder}
                    </label>
                    <input id="txtScore"
                        type="number" 
                        className={cssAssignmentAnswerWindow.txtInput}
                        value={score}
                        placeholder={window.gAppUI.LBL_AnswerScorePlaceHolder}
                        onChange={(event) => ScoreChangeHandler(event)}
                        required 
                        min="0" max="100"
                        />
                </div>
            )
        }
    } // end of RenderSubContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentAnswerWindow.divContent}>
                    {RenderSubContentWrapper(pageIndex, mintTatolPage)}

                    {RenderBottomToolWrapper(mintQuestionType, pageIndex, mintTatolPage, props.AssignmentData.AssignReportStatus)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 標題區域 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderTitleAreaWrapper()
    {
        return (
            <div className={cssAssignmentAnswerWindow.divTitleArea}>
                <div className={cssAssignmentAnswerWindow.divAssignmentIcon}/>

                <div className={cssAssignmentAnswerWindow.divTitle}>
                    {window.gAppUI.LBL_Assignment}
                </div>
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssAssignmentAnswerWindow.divTopTool}>
                {RenderTitleAreaWrapper()}

                <ComponentScore StateUpdateDataTime={updateDataTime} TeacherAssignment={mobjTeacherAssignment}/>

                <div className={cssAssignmentAnswerWindow.divCloseArea}>
                    <div className={cssAssignmentAnswerWindow.btnClose} onClick={() => CloseOnTapHandler()}/>
                </div>
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentAnswerWindow.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper(updateDataTime)}

                {RenderViderPlayerWindowWrapper(isShowViderPlayerWindow)}
                {RenderAudioRecordingWindowWrapper(isShowAudioRecordingWindow)}
                {RenderImageDisplayWindowWrapper(isShowImageDisplayWindow)}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentAnswerWindow